export enum HeaderType {
  PRIMARY_HEADER = 'primary',
  SECONDARY_HEADER = 'secondary',
}

export enum HeaderConstantsData {
  DO_MORE_WITH_SMARTBIZ = 'Do more with the SmartBiz app',
  LOGOUT = 'Logout',
  PROFILE = 'Profile',
}

export enum ImageAlternatives {
  SMARTBIZ = 'SmartBiz',
  GOOGLE_PLAY = 'Google Play',
  SECURITY = 'Security',
  NOTIFICATION = 'Notification',
}
